<template>
  <SubContent  :header_h="'120px'" :h="'500px'" @back="doCancel">
    <template v-slot:nav_left>
      <div class="teachingHeader">
        <div class="teachingHeaderTitle">编辑比赛报告</div>
        <div class="teachingHeaderStatus">
          <p class="statusItem ">第一步：编写比赛报告</p>
          <p class="statusItem active">第二步：比赛评价</p>
        </div>
      </div>
    </template>
    <div class="editTeachingStepTwo">
      <div  class="scroll_wrap">
        <yioks-loading v-if="loading"></yioks-loading>
        <vue-scroll v-else ref="scroll">
          <div class="evaluation">
            <el-form
              ref="evaluation"
              :model="evaluation"
              class="black_form">
              <div class="item_title">比赛总结*</div>
              <el-form-item prop="summary" :rules="[{required: true, message: '请输入比赛总结', trigger: 'blur'}]">
                <el-input
                  v-model="evaluation.summary"
                  :rows="5"
                  placeholder="请输入比赛总结"
                  type="textarea"></el-input>
              </el-form-item>
              <div class="item_title side">
                视频
                <div>
                  <span style="cursor: pointer" @click="addMedia">本地上传视频</span>
                  <span style="margin: 0 10px">/</span>
                  <span style="cursor: pointer" @click="associateMore">从视频库中选择</span>
                </div>
              </div>
              <div class="trainPlan">
                <div
                  v-for="(item,index) in videoToPlayerVos"
                  :key="index"
                  class="mediaDetail"
                  @click.stop="goDetail(item.uuid)">
                  <div class="img">
                    <img
                      class="playImg"
                      :src="playImg"
                      style="position: absolute;top: 30px;left: 65px;"
                      @click.stop="openVideoDialog(item.videoAddress,item.videoCoverAddress)">
                    <img
                      class="coverImg "
                      :src="item.videoCoverAddress || planImg"
                      alt=""
                      style="width: 170px;height:100px"
                      @error="item.videoCoverAddress === planImg" >
                  </div>
                  <div class="intro">
                    <p class="p_item">标题：{{item.videoTitle || '--'}}</p>
                    <p class="p_item">上传人：{{item.authorName}}</p>
                    <p >时长： {{filterTime(parseInt(item.videoDuration / 60))}}:{{ filterTime(item.videoDuration % 60)}}</p>
                  </div>
                </div>
              </div>
              <yioks-empty v-show="videoToPlayerVos.length === 0" :h="'150px'"></yioks-empty>
              <div class="item_title side">
                球员出勤
                <div>
                  是否评价单个球员表现
                  <el-switch
                    v-model="isEvalu"
                    style="margin-left:10px"
                    active-color="#4cd964"
                  ></el-switch>
                </div>
              </div>
              <div class="attendance_wrap">
                <div v-for="(item, index) in playerList" :key="index" class="item">
                  <img :src="item.headImgUrl || person" alt="" @error="item.headImgUrl = person">
                  <div class="info">
                    <div>姓名：{{item.idName}}</div>
                    <div class="slider_wrap">
                      出勤率：{{item.attendance}}%
                    </div>
                  </div>
                </div>
              </div>
              <div v-show="isEvalu" >
                <div class="item_title">{{$t('evaluation')}}</div>
                <div v-for="(item, index) in playerList" :key="index" class="player_box row">
                  <div class="column">
                    <img :src="item.headImgUrl || person" alt="" @error="item.headImgUrl = person">
                    {{item.idName}}
                  </div>
                  <div class="player_info">
                    <div class="row">
                      <div class="border">场上位置</div>
                      <div class="border">个人比赛目标</div>
                      <div class="border">个人比赛评价</div>
                    </div>
                    <div class="row">
                      <div class="row border">
                        <el-select
                          v-model.trim="item.positionId"
                          style="padding:0;margin-left:10px"
                          disabled
                          placeholder="请选择球员场上位置">
                          <el-option
                            v-for="(item, index) in playerOption"
                            :key="index"
                            :label="item.playerPositionName"
                            :value="item.id"
                          >
                          </el-option>
                        </el-select>
                      </div>
                      <div class="border"><el-input v-model="item.learningObjectives" placeholder="请输入球员个人比赛目标" style="padding:0"></el-input></div>
                      <div class="border"><el-input v-model="item.generalEvalComments" placeholder="请输入球员个人比赛评价"  style="padding:0"></el-input></div>
                    </div>
                    <div class="row">
                      <div class="border_right">
                        技术
                        <el-slider
                          v-model="item.technicalScore"
                          :max="10"
                          style="padding:0"
                          :show-tooltip="false"></el-slider>
                        {{item.technicalScore}}分
                      </div>
                      <div class="border_right">
                        战术
                        <el-slider
                          v-model="item.tacticalScore"
                          :max="10"
                          style="padding:0"
                          :show-tooltip="false"></el-slider>
                        {{item.tacticalScore}}分
                      </div>
                      <div class="border_right">
                        体能
                        <el-slider
                          v-model="item.physicalScore"
                          :max="10"
                          style="padding:0"
                          :show-tooltip="false"></el-slider>
                        {{item.physicalScore}}分
                      </div>
                      <div class="border_right">
                        心理
                        <el-slider
                          v-model="item.psychologicalScore"
                          :max="10"
                          style="padding:0"
                          :show-tooltip="false"></el-slider>
                        {{item.psychologicalScore}}分
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-form>
          </div>
        </vue-scroll>
      </div>
    </div>
    <template v-slot:btn>
      <div class="btn_wrap">
        <el-button type="primary" style="margin-right: 20px" @click="checkForm('edit')">暂时保存</el-button>
        <el-button type="primary" style="margin-right: 20px" @click="checkForm('pre')">上一步</el-button>
        <el-button type="primary" style="margin-right: 20px" @click="checkForm('save')" >提交</el-button>
        <el-button type="danger" @click="doCancel" >取消</el-button>
      </div>
    </template>
    <yioks-tip :showTip="showTip" :tipMsg="tips" @callback="goBack"></yioks-tip>
    <template v-if="showVideo">
      <el-dialog
        :visible.sync="showVideo"
        width="800px"
        class="linkAllDialog"
        :close-on-click-modal="false"
        top="12vh">
        <div style="text-align: center;background-color: black;width: 760px" >
          <video
            ref="video"
            controls
            width="760"
            autoplay
            disablePictureInPicture
            :poster="poster"
            controlsList = "nodownload noremoteplayback"
            height="400">
            <source :src="videoSrc" type="video/mp4">
          </video>
        </div>
      </el-dialog>
    </template>
    <template v-if="showDialog">
      <associateMore
        :objectUuid="uuid"
        :type="link.type"
        :obj="propObj"
        :title="link.title"
        :organUuid="orgInfo.organUuid"
        :youthUuid="orgInfo.youthUuid"
        :showDialog.sync="showDialog"
        mediaType="matchReport"
        @hideDialog="hideDialog"></associateMore>
    </template>
    <template v-if="showMediaUpload">
      <uploadMedia
        :showTip.sync="showMediaUpload"
        :orgInfo="orgInfo"
        :uuid="propUuid"
        type="matchReport"
        @hideUploadDialog ="hideUploadDialog"></uploadMedia>
    </template>
  </SubContent>
</template>

<script>
import teaching from '@/api/teaching'
import media from '@/api/media'
import player from '@/api/player'
import person from '@/assets/images/common/person.jpg'
import playImg from '@/assets/images/common/playImg.png'
import planImg from '@/assets/images/common/plan_default.png'
export default {
  name: 'editTeachingSecond',
  components: {
    'SubContent': () => import('@/components/layout/contentWithbtn'),
    'associateMore': () => import('@/components/associatedDialog/associatedMore'),
    'uploadMedia': () => import('@/views/media/uploadMedia')
  },
  filters: {
    filterTime (val) {
      return `${parseInt(val / 60)} 小时 ${val % 60} 分`
    }
  },
  data () {
    return {
      playImg,
      planImg,
      person,
      playerOption: [],
      showTip: false,
      tips: '',
      type: '',
      loading: false,
      isEvalu: false,
      playerList: [],
      evaluation: {
        summary: ''
      },
      uuid: this.$route.query.uuid,
      videoToPlayerVos: [],
      showMediaUpload: false,
      orgInfo: {
        organUuid: '',
        organShortName: '',
        youthUuid: '',
        youthShortName: ''
      },
      propUuid: '',
      showDialog: false,
      link: {
        title: '',
        type: ''
      },
      propObj: {},
      videoSrc: '',
      poster: '',
      showVideo: false
    }
  },
  created () {
    this.getCommonData()
    this.getCommentInfo()
    this.getVideoList()
  },
  methods: {
    filterTime (val) {
      if (val === 0) {
        return '00'
      }
      if (String(val).length < 2) {
        return '0' + String(val)
      } else {
        return val
      }
    },
    doCancel () {
      this.type = ''
      this.tips = '确定放弃保存并返回么？'
      this.showTip = true
    },
    checkForm (type) {
      this.type = type
      if (type === 'save') {
        this.$refs['evaluation'].validate(valid => {
          if (valid) {
            this.tips = '确定保存并提交吗？'
            this.showTip = true
          } else {
            this.$message.error('请完善所有带 * 的必填项')
          }
        })
      } else {
        if (type === 'pre') {
          this.tips = '确定暂时保存并返回上一步吗？'
        } else if (type === 'edit') {
          this.tips = '确定暂时保存并返回吗？'
        }
        this.showTip = true
      }
    },
    goBack (flag) {
      if (flag) {
        if (!this.type) {
          this.$router.push('/teaching/list')
        } else {
          const data = {
            isTempSave: this.type === 'save' ? 0 : 1,
            'commentStatus': this.isEvalu ? 1 : 0,
            'playerFrom': this.playerList.map(item => {
              return {
                'trainingUuid': this.uuid,
                'squadUuid': item.squadUuid,
                'attendance': item.attendance,
                'playerUuid': item.playerUuid,
                // 'position': item.position,
                'generalEvalComments': item.generalEvalComments,
                'learningObjectives': item.learningObjectives,
                'physicalScore': item.physicalScore,
                'psychologicalScore': item.psychologicalScore,
                'tacticalScore': item.tacticalScore,
                'technicalScore': item.technicalScore,
                teachingTeamPlayersId: item.teachingTeamPlayersId
              }
            }),
            'trainingComment': this.evaluation.summary,
            'trainingUuid': this.uuid
          }
          teaching.saveMatchPlayerAttendance(data).then(res => {
            this.showTip = false
            if (res.code) {
              this.$message.error(res.msg)
            } else {
              if (this.type === 'pre') {
                this.$router.go(-1)
              } else if (this.type === 'edit') {
                this.$router.push({
                  path: '/teaching/list',
                  query: {
                    idx: 0
                  }
                })
              } else {
                this.$router.push({
                  path: '/teaching/list',
                  query: {
                    idx: 1
                  }
                })
              }
            }
          }).catch(() => {
            this.showTip = false
          })
        }
      } else {
        this.showTip = false
      }
    },
    getCommonData () {
      player.allPositionList().then(res => {
        this.playerOption = res
      })
    },
    getCommentInfo () {
      this.loading = true
      teaching.getCommentMatchInfo({
        event_uuid: this.uuid
      }).then(res => {
        this.loading = false
        if (res.code) {
          this.$message.error('信息错误')
          // this.$router.push('/home/index')
        } else {
          res.trainingInfo && res.trainingInfo.organUuid && this.$set(this.orgInfo, 'organUuid', res.trainingInfo.organUuid)
          res.trainingInfo && res.trainingInfo.organShortName && this.$set(this.orgInfo, 'organShortName', res.trainingInfo.organShortName)
          res.trainingInfo && res.trainingInfo.youthUuid && this.$set(this.orgInfo, 'youthUuid', res.trainingInfo.youthUuid)
          res.trainingInfo && res.trainingInfo.youthShortName && this.$set(this.orgInfo, 'youthShortName', res.trainingInfo.youthShortName)
          this.evaluation.summary = res.trainingSummary
          this.playerList = res.playerList
          this.isEvalu = !!res.commentStatus
        }
      }).catch(err => {
        this.loading = false
        console.error(err)
      })
    },
    getVideoList () {
      media.videoListToObjectList({
        objectUuid: this.uuid
      }).then(res => {
        this.videoToPlayerVos = res
      })
    },
    openVideoDialog (src, poster) {
      this.videoSrc = src
      this.poster = poster || ''
      this.showVideo = true
    },
    addMedia () {
      this.propUuid = this.uuid
      this.showMediaUpload = true
    },
    associateMore () {
      this.$set(this.link, 'type', 'media')
      this.$set(this.link, 'title', '从视频库中选择')
      this.showDialog = true
    },
    hideUploadDialog (val) {
      this.showMediaUpload = val
      this.getVideoList()
    },
    hideDialog (val) {
      this.showDialog = val
      this.getVideoList()
    },
    goDetail (uuid) {
      this.$router.push({
        path: '/media/detail',
        query: {
          uuid
        }
      })
    }
  }
}
</script>

<style scoped lang="stylus">
  @import '~@/assets/css/variable'
  .teachingHeader
    .teachingHeaderTitle
      padding 15px  0 10px 0
      border-bottom 1px solid white
      width 800px
    .teachingHeaderStatus
      margin-top 10px
      display flex
      align-items center
      padding 5px 0  15px 0
      .active
        padding 8px 15px
        background-color #4cd964
      .statusItem
        margin-right 20px
  .editTeachingStepTwo
    padding-top 15px
    height 480px
    .scroll_wrap
      height 100%
      overflow hidden
      .black_form
        margin 0 20px 40px
      .evaluation
        font-size 16px
        .item_title
          padding  20px 0
          margin-bottom 20px
          border-bottom 1px solid #FFF
          &.side
            display flex
            justify-content space-between
        .attendance_wrap
          display flex
          flex-wrap wrap
          .item
            display flex
            align-items center
            border 1px solid #FFF
            padding 10px
            margin 0 10px 10px 0
            img
              width 50px
              height 50px
              border-radius 50px
              margin-right 10px
            .slider_wrap
              min-width 130px
              display flex
              align-items center
              margin-top 5px
              .slider
                flex 1
            .attendanceNum
              text-align center
              padding-left 50px
        .trainPlan
          display flex
          justify-content space-between
          flex-wrap wrap
          .planDetail
            border  1px solid white
            width 100%
            .row
              min-height 49px
              display flex
              align-items center
              border-bottom 1px solid white
              &:last-child
                border-bottom   none
              .col
                width:  50%
                padding 0 10px 0 20px
                height 100%
                line-height 49px
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                &:first-child
                  border-right  1px solid white
            .rowLine
              padding: 10px  10px  10px 20px
          .mediaDetail
            background-color rgba(0,0,0,0.7)
            border  1px solid white
            padding  20px
            width 400px
            display flex
            align-items center
            cursor pointer
            margin-bottom 20px
            .p_item
              margin-bottom 10px
          .img
            width 170px
            height 100px
            position relative
            .coverImg
              width 100%
              height 100%
          .intro
            padding-left 10px
            width: calc(100% - 170px);
            height 100px
            display flex
            flex-direction column
            justify-content space-between
        .player_box
          border 1px solid #FFF
          border-right 0
          margin-bottom 20px
          margin-right 12px
        .row
          display flex
          align-items center
          justify-content center
          .column
            text-align center
            img
              width 80px
              height 80px
              border-radius 80px
              margin 0 10px 20px
          .player_info
            flex 1
            border-left 1px solid #FFF
            .row
              div
                flex 1
                padding 10px
                text-align center
              .border
                border-right 1px solid #FFF
                border-bottom 1px solid #FFF
              .border_right
                border-right 1px solid #FFF

  .btn_wrap
    width 100%
    display flex
    justify-content center
</style>
